<script setup>
import {ref, defineExpose, getCurrentInstance} from "vue";
import { useRouter } from 'vue-router'
import { storeToRefs } from "pinia";
import { useUserStore } from "../../../stores/user";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import MyPageCorpJobFairCorpInfoView from "../../../views/mypage/corpJobFair/MyPageCorpJobFairCorpInfoView.vue";
import mypageJobFairJobNoticeService from "../../../services/mypage/jobFair/mypageJobFairJobNoticeService";
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import mypageJobFairService from "../../../services/mypage/jobFair/mypageJobFairService";
import JobFairJobNoticeDetailModal from "./JobFairJobNoticeDetailModal.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const router = useRouter();
const loadingStore = usePageLoadingStore()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo, alert, confirm, $gbNameKR } = globals;

const jobNoticeList = ref([]);
const currentPage = ref(1);
const pageSize = 3;
const totalPages = ref(1);
const totalCount = ref(0);

const baseModal = ref(null);
const resolvePromise = ref(null);
const jobNoticeModal = ref(null); // 채용공고 보기

const modalBody = ref(null)

const corpLikeTxts = ref("♡관심기업");
const currentCorpId = ref(0);
const interestYn = ref('N'); // 구직자: 면접제안 여부 / 기업: 사용자의 회사아이디

const isCorpMaster = ref(false);
const isStudent = ref(false);

// 기업 정보 조회
const retrieveCorporationDetail = (corpId) => {
  // 모달 재오픈 시 이전 사용자 상태가 남지 않도록 초기화
  isCorpMaster.value = false;
  isStudent.value = false;

  loadingStore.loading = true;
  mypageJobFairService.retrieveCorporation(corpId)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        modalBody.value.setCorpInfo(result);

        const userCorpId = user.value.userInfo.corporation.corpId;
        const userCorpMasterYn = user.value.userInfo.corpMasterYn;

        if((result.corpId === userCorpId) && userCorpMasterYn === 'Y') { // 기업마스터 여부
          isCorpMaster.value = true;
          isStudent.value = false;
        } else if(user.value.userInfo.userGb === 'STUDENT') { // 학생
          isCorpMaster.value = false;
          isStudent.value = true;
        } else {
          isCorpMaster.value = false;
          isStudent.value = false;
        }
      }
    }).catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 기업의 채용공고 목록 조회
const retrieveJobNoticeList = (corpId) => {
  loadingStore.loading = true;
  let paramObj = {
    corpId: corpId || currentCorpId.value,
    pageNumber: currentPage.value,
    size: pageSize,
  }
  mypageJobFairJobNoticeService.retrieveAllJobNoticeByCorpId(paramObj)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize, currentPage.value);
      }
    })
    .catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 채용공고 보기
const onClickJobNotice = async (jobNotice) => {
  const result = await jobNoticeModal.value.show({
    jobNoticeSeq: jobNotice.jobNoticeSeq,
    corpId: jobNotice.corpId,
    inteYn: jobNotice.interestYn !== 'N' ? 'Y' : 'N',
  });

  if(result && result.interestNoticeYn) {
    jobNotice.interestYn = result.interestNoticeYn;
  }
}

// 기업 관심여부 조회
const retrieveInterestHallEntryYn = (corpId) => {
  mypageJobFairService.retrieveInterestHallEntryYn(corpId)
    .then( (res) => {
      if(res.data.code.toLowerCase() === 'success') {
        interestYn.value = res.data.result;
        corpLikeTxts.value = interestYn.value === 'Y' ? "♥관심기업" : "♡관심기업";
      }
    })
    .catch( (error) =>  {
      interestYn.value = 'N';
      corpLikeTxts.value = "♡관심기업";
    });
}

const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveJobNoticeList();
}

// 기업정보 수정
const onClickCorpUpdate = () => {
  router.push({ name: 'MyPageCorpInfoUpdate', query: { corpId: currentCorpId.value } })
}

// 관심 기업 관심여부
const onClickCorpYn = async () => {
  const inteYn = interestYn.value === 'Y' ? 'N' : 'Y';
  const inteYnName = inteYn === 'Y' ? '등록' : '삭제';
  const ok = await confirm([`관심기업을 ${inteYnName}하시겠습니까?`], `관심기업 ${inteYnName}`, "취소");

  if (ok) {
    let paramObj = {
      corpId: currentCorpId.value,
      interestYn: inteYn,
    }

    mypageJobFairService.updateInterestHallEntryYn(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          //const result = res.data.result;
          if (inteYn === 'Y') {
            alert([`${inteYnName}하였습니다.`]);
            corpLikeTxts.value = "♥관심기업";
            interestYn.value = "Y";
          } else {
            alert([`${inteYnName}하였습니다.`]);
            corpLikeTxts.value = "♡관심기업";
            interestYn.value = "N";
          }
        } else {
          alert("실패하였습니다.");
        }
      })
      .catch( (res) =>  {
        loadingStore.loading = false;
        alert("실패하였습니다.");
      });
  }
}

const show = ({ corpId, interestYn: inteYn }) => {
  if(corpId) {
    currentCorpId.value = corpId;
    retrieveCorporationDetail(corpId);
    retrieveJobNoticeList(corpId);
    retrieveInterestHallEntryYn(corpId);
  }

  interestYn.value = inteYn || 'N';
  
  if (interestYn.value === 'Y') {
    corpLikeTxts.value = "♥관심기업"
  } else {
    corpLikeTxts.value = "♡관심기업"
  }
  
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const _confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(interestYn.value);
};

defineExpose({
  show,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <MyPageCorpJobFairCorpInfoView ref="modalBody"/>
        <!-- s : 채용 공고 목록 -->
        <div class="mt-sm gray-bg">
          <div class="resume-wrap">
            <section>
              <h2 class="mb-sm">채용 공고</h2>
              <div class="table-form">
                <table class="table-form vertical" v-if="jobNoticeList !== null">
                  <tr>
                    <th>채용상태</th>
                    <th>채용 공고 제목</th>
                    <th>관심 카테고리</th>
                    <th>직무</th>
                  </tr>
                  <tr v-for="jobNotice in jobNoticeList">
                    <td>{{ $gbNameKR('JOB_NOTICE_STATE_GB', jobNotice.jobNoticeStateGb) }}</td>
                    <td class="link blue text-overflow long-overflow" @click="onClickJobNotice(jobNotice)">{{ jobNotice.jobName }}</td>
                    <td>{{ jobNotice.interests }}</td>
                    <td>{{ jobNotice.job }}</td>
                  </tr>
                </table>
              </div>
            </section>
          </div>
          <Paginate
              v-if="jobNoticeList.length > 0"
              v-model="currentPage"
              :page-count="totalPages"
              :click-handler="onSelectedPage"
          />
        </div>
        <!-- e : 채용 공고 목록 -->
      </div>
      <div v-if="isCorpMaster" class="modal-footer btn-wrap">
        <KSAPrimaryButton text="수정" @click="onClickCorpUpdate()" style="margin-left: auto" />
      </div>
      <div v-if="isStudent" class="modal-footer btn-wrap">
        <KSASecondaryButton :text="corpLikeTxts" @click="onClickCorpYn()" class="red_button"/>
      </div>
    </div>
  </Modal>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .file, .link {
    color: $blue_color;
    cursor: pointer;
  }
  .link {
    color: $blue_color;
    text-decoration: underline;
  }
  .gray-bg {
    background: $gray-thin_color;
    padding: 30px;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>
